import { useTranslation } from 'react-i18next';
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { CalendarView } from "@/components/CalendarView";

export function CalendarPage() {
  const { t } = useTranslation('public');
  return (
    <div className="flex min-h-screen flex-col">
      <Header />

      <main className="global-container flex-1">
        <header className="flex flex-col gap-2.5 border-b border-rule pb-6 pt-8 md:pb-8 md:pt-10">
          <span className="kicker">{t('brand.calendar')}</span>
          <h1 className="m-0 text-[2rem] leading-none md:text-[3rem]">{t('nav.calendar')}</h1>
        </header>
        <CalendarView />
      </main>

      <Footer />
    </div>
  );
}
